import type { Template } from "@/types";

export const PO_04_H3_V1: Template[] = [
    {
        id: "po-04-h3v1-01",
        name: "PO 01 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 96, y: 85, width: 436, height: 612, rotation: 0, imageRotation: 0 },
            { id: "2", x: 800, y: 0, width: 394, height: 256, rotation: 0, imageRotation: 0 },
            { id: "3", x: 800, y: 263, width: 394, height: 256, rotation: 0, imageRotation: 0 },
            { id: "4", x: 800, y: 527, width: 394, height: 256, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-02",
        name: "PO 02 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 56, y: 56, width: 478, height: 672, rotation: 0, imageRotation: 0 },
            { id: "2", x: 841, y: 56, width: 355, height: 220, rotation: 0, imageRotation: 0 },
            { id: "3", x: 841, y: 282, width: 355, height: 220, rotation: 0, imageRotation: 0 },
            { id: "4", x: 841, y: 509, width: 355, height: 219, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-03",
        name: "PO 03 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 118, y: 56, width: 355, height: 220, rotation: 0, imageRotation: 0 },
            { id: "2", x: 118, y: 282, width: 355, height: 220, rotation: 0, imageRotation: 0 },
            { id: "3", x: 118, y: 509, width: 355, height: 219, rotation: 0, imageRotation: 0 },
            { id: "4", x: 699, y: 56, width: 478, height: 672, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-04",
        name: "PO 04 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 80, y: 176, width: 466, height: 275, rotation: 0, imageRotation: 0 },
            { id: "2", x: 80, y: 457, width: 230, height: 150, rotation: 0, imageRotation: 0 },
            { id: "3", x: 316, y: 457, width: 230, height: 150, rotation: 0, imageRotation: 0 },
            { id: "4", x: 699, y: 56, width: 478, height: 672, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-05",
        name: "PO 05 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 80, y: 176, width: 230, height: 150, rotation: 0, imageRotation: 0 },
            { id: "2", x: 316, y: 176, width: 230, height: 150, rotation: 0, imageRotation: 0 },
            { id: "3", x: 80, y: 333, width: 466, height: 275, rotation: 0, imageRotation: 0 },
            { id: "4", x: 785, y: 176, width: 308, height: 432, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-06",
        name: "PO 06 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 52, y: 160, width: 523, height: 308, rotation: 0, imageRotation: 0 },
            { id: "2", x: 52, y: 474, width: 258, height: 164, rotation: 0, imageRotation: 0 },
            { id: "3", x: 317, y: 474, width: 257, height: 164, rotation: 0, imageRotation: 0 },
            { id: "4", x: 626, y: 1, width: 625, height: 783, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-07",
        name: "PO 07 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 74, y: 56, width: 478, height: 672, rotation: 0, imageRotation: 0 },
            { id: "2", x: 706, y: 332, width: 466, height: 275, rotation: 0, imageRotation: 0 },
            { id: "3", x: 942, y: 175, width: 230, height: 150, rotation: 0, imageRotation: 0 },
            { id: "4", x: 706, y: 175, width: 230, height: 150, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-08",
        name: "PO 08 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 167, width: 307, height: 221, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 395, width: 307, height: 221, rotation: 0, imageRotation: 0 },
            { id: "3", x: 314, y: 167, width: 621, height: 449, rotation: 0, imageRotation: 0 },
            { id: "4", x: 944, y: 167, width: 307, height: 449, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-09",
        name: "PO 09 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 52, y: 54, width: 456, height: 676, rotation: 0, imageRotation: 0 },
            { id: "2", x: 514, y: 521, width: 340, height: 209, rotation: 0, imageRotation: 0 },
            { id: "3", x: 514, y: 54, width: 687, height: 460, rotation: 0, imageRotation: 0 },
            { id: "4", x: 861, y: 521, width: 340, height: 209, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-10",
        name: "PO 10 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 191, y: 74, width: 271, height: 360, rotation: 0, imageRotation: 0 },
            { id: "2", x: 191, y: 440, width: 431, height: 271, rotation: 0, imageRotation: 0 },
            { id: "3", x: 468, y: 74, width: 592, height: 360, rotation: 0, imageRotation: 0 },
            { id: "4", x: 630, y: 440, width: 431, height: 271, rotation: 0, imageRotation: 0 }
        ],
    }
];